import isEmpty from 'lodash/isEmpty';
import fromPairs from 'lodash/fromPairs';
import types from 'shared/constants/json/transportTypes.json';
import {
  setTargetingArguments,
  setLocation,
  setSeoSearchUrl,
  seoRequest,
} from 'shared/actions/globals';
import { resetAll, setFormVocabulary } from 'shared/actions/searchForm';
import { removeLocaleFromHref } from 'shared/helpers/locale';
import { getAdsContext, getPriceValuation } from 'shared/helpers/adsAndMetrics';
import API from 'shared/constants/api';

export default async function({ store, query, baseUrl, path, fetch }, seoRes) {
  const url = removeLocaleFromHref(`${baseUrl}${path}`.replace('//', '/'));
  const missingVocabularyFields = [];
  // Skip this route for permalinks
  if (url.includes('.html')) {
    return null;
  }

  const state = store.getState();
  const {
    globals: { location: storeLocation },
    searchForm: { vocabulary },
  } = state;
  let seoResponse = seoRes || (await store.dispatch(seoRequest(url)));
  if (isEmpty(seoResponse)) {
    seoResponse = {
      characteristics: {},
      firms: true,
      kind: '',
      meta: {
        description: '',
        h1: '',
        title: '',
      },
    };
  }
  store.dispatch(setSeoSearchUrl({ ...seoResponse, url }));
  const { characteristics, kind, meta, ...seoQuery } = seoResponse;
  const transportType = seoQuery.transport || types.find(i => i.slug === 'avto');
  const transportID = transportType.id;
  if (!vocabulary.categories) {
    missingVocabularyFields.push('categories');
  }
  const fetchedVocabulary = await Promise.all(
    missingVocabularyFields.map(field =>
      API.VOCABULARY[field]
        ? fetch(API.VOCABULARY[field](transportType.id))
            .then(r => r.json())
            .then(response => ({ [field]: response }))
        : Promise.resolve({}),
    ),
  );
  const mergedVocabulary = fetchedVocabulary.reduce(
    (results, pair) => ({ ...results, ...pair }),
    {},
  );
  store.dispatch(
    setFormVocabulary({
      ...mergedVocabulary,
    }),
  );
  const {
    searchForm: {
      vocabulary: { categories },
    },
  } = store.getState();
  let body;
  for (let a = 0; a < categories.length; a += 1) {
    const buf = categories[a] && categories[a].title && categories[a].id;
    if (buf && query.category && String(buf) === query.category) {
      body = categories[a];
      break;
    }
  }

  if (seoQuery.location && seoQuery.location.is_country) {
    return null;
  }

  if (storeLocation && storeLocation.is_country) {
    store.dispatch(setLocation(null));
  }

  const prevSelectedTransport = state.searchForm.selected && state.searchForm.selected.transport;
  if (prevSelectedTransport && prevSelectedTransport.id !== transportID) {
    store.dispatch(resetAll());
  }

  const storeParams = fromPairs(
    Object.entries(store.getState().searchForm.selected)
      .map(([key, value]) => [key, value && value.id ? value.id : value])
      .filter(([, value]) => value && (typeof value === 'string' || typeof value === 'number')),
  );

  const selected = store.getState().searchForm.selected || {};
  const queryRubric = query.rubric || (selected.rubric && selected.rubric.id);
  const querySparetype = query.sparetype || (selected.sparetype && selected.sparetype.id);
  const currency = selected && selected.currency;
  const q = {
    ...storeParams,
    ...query,
    transport: transportID,
    ...(queryRubric
      ? {
          rubric: queryRubric,
        }
      : {}),
    ...(querySparetype
      ? {
          sparetype: querySparetype,
        }
      : {}),
  };
  let location = store.getState().globals.location;

  if (seoQuery.make) {
    q.make = seoQuery.make.id;
  }
  if (seoQuery.model) {
    q.model = seoQuery.model.id;
  }
  if (seoQuery.rubric) {
    q.rubric = seoQuery.rubric.id;
  }
  if (seoQuery.part_type) {
    q.sparetype = seoQuery.part_type.id;
  }

  if (seoQuery.location) {
    location = seoQuery.location;
    store.dispatch(setLocation(seoQuery.location));
  }

  q.location = (location && location.id) || undefined;
  q.currency = currency.slug;
  const seo = {
    ...seoQuery,
    ...location,
  };
  const targetingArguments = getAdsContext({
    make: seo.make,
    model: seo.model,
    isMain: seo.isMain,
    isNew: seo.isNew,
    rubric: seo.rubric,
    isCustomCleared: seo.isCustomCleared,
    location: seo.location,
    isCountry: seo.isCountry,
    transport: transportType,
    category: {
      slug: body,
    },
    engine: seo.engine,
    dealer: seo.rubric,
    price: getPriceValuation(
      {
        from: q.priceFrom,
        to: q.priceTo,
      },
      q.currency,
    ),
    page: baseUrl.replace(/\//g, ''),
    id: seo.slug,
  });
  store.dispatch(setTargetingArguments(targetingArguments));
  return {
    targetingArguments,
  };
}



// WEBPACK FOOTER //
// ./src/shared/modules/targeting.js